import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d1e2538"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "prependIcon h-100 px-2 d-flex align-center"
}
const _hoisted_2 = { class: "d-flex justify-between align-center ms-2" }
const _hoisted_3 = { class: "color_picker" }
const _hoisted_4 = { class: "placeholder" }
const _hoisted_5 = {
  key: 1,
  class: "appendIcon h-100 px-2 d-flex align-center"
}
const _hoisted_6 = {
  key: 2,
  class: "error-msg"
}

import { ref, withDefaults } from 'vue';
import { ColorInputWithoutInstance } from 'tinycolor2';
import { watch } from 'vue';

const __default__ = {
  inheritAttrs: false,
};

interface InputProps {
  placeholder?: string;
  modelValue?: any;
  label?: string;
  msgError?: string;
  borderColor?: string;
  height?: string | number;
  filled?: boolean;
  simple?: boolean;
  selectionOnFocus?: boolean;
  noStyle?: boolean;
  prependIcon?: boolean;
  appendIcon?: boolean;
  noBgPrependIcon?: boolean;
  noBorderPrependIcon?: boolean;
  noBgAppendIcon?: boolean;
  disabled?: boolean;
  required?: boolean;
  hasError?: boolean;
  wFull?: boolean;
  borderBottom?: boolean;
  nullable?: boolean;
  trim?: boolean;
  classes?: string;
  sizeLabel?: string;
  fontWeight?: string;
  useTooltip?: boolean;
  tooltipMessage?: string;
  isDescription?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AtomInputColor',
  props: {
    placeholder: {},
    modelValue: { default: '' },
    label: {},
    msgError: {},
    borderColor: { default: 'gray-500' },
    height: { default: 2.25 },
    filled: { type: Boolean, default: false },
    simple: { type: Boolean },
    selectionOnFocus: { type: Boolean },
    noStyle: { type: Boolean, default: false },
    prependIcon: { type: Boolean, default: undefined },
    appendIcon: { type: Boolean, default: undefined },
    noBgPrependIcon: { type: Boolean, default: false },
    noBorderPrependIcon: { type: Boolean, default: false },
    noBgAppendIcon: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean },
    hasError: { type: Boolean },
    wFull: { type: Boolean, default: false },
    borderBottom: { type: Boolean },
    nullable: { type: Boolean },
    trim: { type: Boolean },
    classes: { default: '' },
    sizeLabel: {},
    fontWeight: {},
    useTooltip: { type: Boolean },
    tooltipMessage: {},
    isDescription: { type: Boolean }
  },
  emits: ["update:modelValue", "click", "keydown", "focus", "update:hint"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const pureColor = ref<ColorInputWithoutInstance>(props.modelValue);

const emit = __emit;

watch(
  () => props.modelValue,
  (v) => {
    pureColor.value = v;
  }
);
watch(props.modelValue, () => {
  pureColor.value = props.modelValue.toLowerCase();
});
watch(pureColor, () => {
  emit('update:modelValue', pureColor.value);
});

const color = ref();
function handleColorPicker() {
  color.value.onShowPicker();
}

return (_ctx: any,_cache: any) => {
  const _component_AtomTooltipInfo = _resolveComponent("AtomTooltipInfo")!
  const _component_color_picker = _resolveComponent("color-picker")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${_ctx.classes} text-c600`),
    onClick: handleColorPicker
  }, [
    (props.useTooltip)
      ? (_openBlock(), _createBlock(_component_AtomTooltipInfo, {
          key: 0,
          text: props.tooltipMessage
        }, {
          default: _withCtx(() => [
            (props.label)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  style: _normalizeStyle({ fontSize: props.sizeLabel === 'lg' ? '18px' : '', fontWeight: props.fontWeight }),
                  class: "input_label label"
                }, _toDisplayString(props.label) + ":", 5))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["text"]))
      : (props.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 1,
            style: _normalizeStyle({ fontSize: props.sizeLabel === 'lg' ? '18px' : '', fontWeight: props.fontWeight }),
            class: "input_label label mb-3"
          }, _toDisplayString(props.label) + ":", 5))
        : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["input-wapper d-flex", _ctx.hasError ? 'error' : '']),
      style: _normalizeStyle({ height: _ctx.height ? _ctx.height : '40px' })
    }, [
      (_ctx.prependIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "prependIcon")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_color_picker, {
            ref_key: "color",
            ref: color,
            format: "hex",
            pureColor: pureColor.value,
            "onUpdate:pureColor": _cache[0] || (_cache[0] = ($event: any) => ((pureColor).value = $event)),
            pickerType: "chrome"
          }, null, 8, ["pureColor"])
        ]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(pureColor.value ? pureColor.value : _ctx.placeholder), 1)
      ]),
      (_ctx.appendIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "appendIcon")
          ]))
        : _createCommentVNode("", true)
    ], 6),
    (_ctx.hasError && _ctx.msgError)
      ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.msgError), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})